import * as Pi from "react-icons/pi";
import { useLocation, useNavigate } from 'react-router';

export default function NavbarMobile() {

  const location = useLocation()

  const navMenuItems = [
    {labelText: 'Home', iconPathLocation: '/', iconNormal: <Pi.PiHouseSimpleDuotone />, iconActive: <Pi.PiHouseSimpleFill />},
    // {labelText: 'search', iconPathLocation: '/search', iconNormal: <Pi.PiMagnifyingGlassDuotone />, iconActive: <Pi.PiMagnifyingGlassFill />},
    // {labelText: 'Carrito', iconPathLocation: '/carrito', iconNormal: <Pi.PiShoppingCartDuotone />, iconActive: <Pi.PiShoppingCartFill />},
    // {labelText: 'Notif', iconPathLocation: '/notification-center', iconNormal: <Pi.PiBellSimpleDuotone />, iconActive: <Pi.PiBellSimpleFill />},
    {labelText: 'Perfil', iconPathLocation: '/profile', iconNormal: <Pi.PiUserDuotone />, iconActive: <Pi.PiUserFill /> },
  ]

  return (
    <ol className='card sticky bottom-0 flex justify-around p-4 m-4 z-50'>
      {
        navMenuItems.map((item, i)=>
          <NavItem
            key={i}
            itemPath={item.iconPathLocation}
            active={location.pathname === item.iconPathLocation}
            labelText={item.labelText}
            icon={location.pathname === item.iconPathLocation ? item.iconActive : item.iconNormal}/>
        )
      }
    </ol>
  )
}

function NavItem({...props}){
  const navigate = useNavigate()

  return(
    <li className={props.active ? 'text-lila-muyShiny cursor-pointer flex flex-col items-center' : 'text-texto-secundario cursor-pointer flex flex-col items-center'} onClick={()=> navigate(props.itemPath)}>
      <span className='text-2xl'>{props.icon}</span>
      <span className='text-xs mt-1'>{props.labelText}</span>
    </li>
  )
}